export default {
  
   /*
   *  Punch endpoints
  */
  punchIn: function( params ){
    return this.apiCall( 'POST', '/punch-in', params );
  },
  
  punchOut: function( params ){
    return this.apiCall( 'POST', '/punch-out', params );
  },
  
  createPunch: function( params ){
    return this.apiCall( 'PUT', '/punch', params );
  },
  
  updatePunch: function( punchid, params ){
    return this.apiCall( 'POST', '/punch/' + punchid, params );
  },
  
  updatePunchNotes: function( punchid, params ){
    return this.apiCall( 'POST', '/punch/' + punchid + '/notes', params );
  },
  
  deletePunch: function( punchid, params ){
    return this.apiCall( 'DELETE', '/punch/' + punchid, params );
  },
  
  continuePunch: function( params ){
    return this.apiCall( 'POST', '/punch-continue', params );
  },
  
  assignPunchToGap: function( params ){
    return this.apiCall( 'POST', '/punch-assign', params );
  },
  
  
   /*
   *  Data endpoints
  */
  getPageState: function( params ){
    return this.apiCall( 'GET', '/state', params );
  },
  
  getDashboardData: function( params ){
    return this.apiCall( 'GET', '/dashboard', params );
  },
  
  getOmniboxData: function( params ){
    return this.apiCall( 'GET', '/omnibox', params );
  },
  
  getProjects: function( params ){
    return this.apiCall( 'GET', '/projects', params );
  },
  
  getClients: function( params ){
    return this.apiCall( 'GET', '/clients', params );
  },
  
  getTasks: function( params ){
    return this.apiCall( 'GET', '/tasks', params );
  },
  
  getLedger: function( params ){
    return this.apiCall( 'GET', '/ledger', params );
  },
  
  getTimezones: function( params ){
    return this.apiCall( 'GET', '/timezones', params );
  },
  
  getTeamAction: function( params ){
    return this.apiCall( 'GET', '/team-action', params );
  },
  
  getHistory: function( params ){
    return this.apiCall( 'GET', '/history', params );
  },
  
  getBillingDetails: function( params ){
    return this.apiCall( 'GET', '/billing', params );
  },
  
  getBillingInvoice: function( invoicenumber, params ){
    return this.apiCall( 'GET', '/billing/invoice/' + invoicenumber, params );
  },
  
  getCheckInData: function( params ){
    return this.apiCall( 'GET', '/check-in', params );
  },
  
  
   /*
   *  Billing endpoints
  */
  upgradeToPunchPro: function( params ){
    return this.apiCall( 'POST', '/upgrade', params );
  },
  
  
   /*
   *  Client endpoints
  */
  getClient: function( clientid, params ){
    return this.apiCall( 'GET', '/client/' + clientid, params );
  },
  addClient: function( params ){
    return this.apiCall( 'PUT', '/client', params );
  },
  addClients: function( params ){
    return this.apiCall( 'PUT', '/clients', params );
  },
  updateClient: function( clientid, params ){
    return this.apiCall( 'POST', '/client/' + clientid, params );
  },
  
  
   /*
   *  Project endpoints
  */
  addProject: function( params ){
    return this.apiCall( 'PUT', '/project', params );
  },
  addProjects: function( params ){
    return this.apiCall( 'PUT', '/projects', params );
  },
  getProject: function( projectid, params ){
    return this.apiCall( 'GET', '/project/' + projectid, params );
  },
  updateProject: function( projectid, params ){
    return this.apiCall( 'POST', '/project/' + projectid, params );
  },
  starProject: function( projectid, params ){
    return this.apiCall( 'POST', '/project/' + projectid + '/star', params );
  },
  completeProject: function( projectid, params ){
    return this.apiCall( 'POST', '/project/' + projectid + '/complete', params );
  },
  updateDefaultProjects: function( params ){
    return this.apiCall( 'POST', '/default-projects', params );
  },
  updateProjectStatus: function( projectid, params ){
    return this.apiCall( 'PUT', '/project/' + projectid + '/status', params );
  },
  deleteProjectStatus: function( projectid, statusid, params ){
    return this.apiCall( 'DELETE', '/project/' + projectid + '/status/' + statusid, params );
  },
  
  
   /*
   *  Task endpoints
  */
  createTask: function( params ){
    return this.apiCall( 'PUT', '/task', params );
  },
  updateTask: function( taskid, params ){
    return this.apiCall( 'POST', '/task/' + taskid, params );
  },
  deleteTask: function( taskid, params ){
    return this.apiCall( 'DELETE', '/task/' + taskid, params );
  },
  updateTaskSeq: function( params ){
    return this.apiCall( 'POST', '/task-seq', params );
  },
  
  
   /*
   *  Note endpoints
  */
  createNote: function( params ){
    return this.apiCall( 'PUT', '/note', params );
  },
  
  updateNote: function( noteid, params ){
    return this.apiCall( 'POST', '/note/' + noteid, params );
  },
  
  deleteNote: function( noteid, params ){
    return this.apiCall( 'DELETE', '/note/' + noteid, params );
  },
  
  
   /*
   *  Queue endpoints
  */
  getQueue: function( params ){
    return this.apiCall( 'GET', '/queue-all', params );
  },
  
  addToQueue: function( params ){
    return this.apiCall( 'PUT', '/queue', params );
  },
  
  deleteFromQueue: function( queueid, params ){
    return this.apiCall( 'DELETE', '/queue/' + queueid, params );
  },
  
  updateQueue: function( queueid, params ){
    return this.apiCall( 'POST', '/queue/' + queueid, params );
  },
  
  updateQueueSeq: function( params ){
    return this.apiCall( 'POST', '/queue-seq', params );
  },
  
  
   /*
   *  User endpoints
  */
  
  getUser: function( userid, params ){
    return this.apiCall( 'GET', '/user/' + userid, params );
  },
  
  getCurrentUser: function(){
    return this.apiCall( 'GET', '/me' );
  },
  
  getAccountSettings: function(){
    return this.apiCall( 'GET', '/account-settings' );
  },
  
  updateUser: function( params ){
    return this.apiCall( 'POST', '/me', params );
  },
  
  updatePassword: function( params ){
    return this.apiCall( 'POST', '/me/password', params );
  },
  
  checkIn: function( params ){
    return this.apiCall( 'POST', '/check-in', params );
  },
  
  clearCheckIn: function(){
    return this.apiCall( 'DELETE', '/check-in' );
  },
  
  updateTimezone: function( params ){
    return this.apiCall( 'POST', '/me/timezone', params );
  },
  
  updateNotifications: function( params ){
    return this.apiCall( 'POST', '/me/notifications', params );
  },
  
  resendVerification: function( params ){
    return this.apiCall( 'POST', '/account/resend-verification', params );
  },
  
  addUser: function( params ){
    return this.apiCall( 'PUT', '/user', params );
  },
  
  setSetting: function( params ){
    return this.apiCall( 'POST', '/settings', params );
  },
  
  getWebAuthnChallenge: function( params ){
    return this.apiCall( 'POST', '/webauthn-challenge', params );
  },
  
  verifyWebAuthnChallenge: function( params ){
    params.contentType = null;
    return this.apiCall( 'POST', '/webauthn-verify', params );
  },
  
  registerWebAuthn: function( params ){
    params.contentType = null;
    return this.apiCall( 'POST', '/webauthn-register', params );
  },
  
  deregisterWebAuthn: function( params ){
    params.contentType = null;
    return this.apiCall( 'POST', '/webauthn-deregister', params );
  },
  
  
   /*
   *  Team endpoints
  */
  
  getTeam: function( params ){
    return this.apiCall( 'GET', '/team', params );
  },
  
  getTeamData: function( params ){
    return this.apiCall( 'GET', '/team/data', params );
  },
  
  updateTeam: function( params ){
    return this.apiCall( 'POST', '/team', params );
  },
  
  updateBilling: function( params ){
    return this.apiCall( 'POST', '/billing', params );
  },
  
  connectToXero: function( params ){
    return this.apiCall( 'POST', '/xero/connect', params );
  },
  
  disconnectXero: function( params ){
    return this.apiCall( 'POST', '/xero/disconnect', params );
  },
  
  updateXero: function( params ){
    return this.apiCall( 'POST', '/team/xero', params );
  },
  
  syncXeroContacts: function( params ){
    return this.apiCall( 'POST', '/xero/contacts/sync', params );
  },
  
  getXeroContacts: function( params ){
    return this.apiCall( 'GET', '/xero/contacts', params );
  },
  
  createContactsFromXero: function( params ){
    return this.apiCall( 'PUT', '/xero/contacts', params );
  },
  
  
   /*
   *  Invoicing endpoints
  */
  
  getInvoice: function( invoiceid, params ){
    return this.apiCall( 'GET', '/invoices/' + invoiceid, params );
  },
  
  createInvoice: function( clientid, params ){
    return this.apiCall( 'PUT', '/invoicing/' + clientid, params );
  },
  
  getInvoicingData: function( params ){
    return this.apiCall( 'GET', '/invoicing', params );
  },
  
  getInvoicingClientData: function( clientid, params ){
    return this.apiCall( 'GET', '/invoicing/' + clientid, params );
  },
  
  
   /*
   *  Report endpoints
  */
  getReportLast12Months: function( params ){
    return this.apiCall( 'GET', '/reports/last12months', params );
  },
  
  
   /*
   *  Push subscription endpoints
  */
  updatePushSubscription: function( params ){
    return this.apiCall( 'POST', '/push-subscription', params );
  },
  
  
   /*
   *  Onboarding endpoints
  */
  getOnboarding: function( params ){
    return this.apiCall( 'GET', '/onboarding', params );
  },
  
  setOnboarding: function( params ){
    return this.apiCall( 'POST', '/onboarding', params );
  },
  
  setOnboardingStage: function( params ){
    return this.apiCall( 'POST', '/onboarding-stage', params );
  },
  
  getOnboardingStage: function( params ){
    return this.apiCall( 'GET', '/onboarding-stage', params );
  },
  
  completeOnboarding: function( params ){
    return this.apiCall( 'POST', '/onboarding-complete', params );
  },
  
  
   /*
   *  Other endpoints
  */
  updateManager: function( userid, params ){
    return this.apiCall( 'POST', '/user/' + userid + '/manager', params );
  },
  
  submitFeedback: function( params ){
    return this.apiCall( 'POST', '/feedback', params );
  },
  
  
   /*
   *  Add-on endpoints
  */
  
  
   /*
   *  Bitbucket
  */
  disconnectFromBitbucket: function( params ){
    return this.apiCall( 'GET', '/bitbucket/disconnect', params );
  },
  
  getBitbucketRepositories: function( params, force ){
    if( force ){
      params.data.force = true;
    }
    return this.apiCall( 'GET', '/bitbucket/repositories', params );
  },
  
  updateBitbucketRepository: function( uuid, params ){
    return this.apiCall( 'POST', '/bitbucket/repository/' + uuid, params );
  },
  
  getBitbucketIssues: function( params, force ){
    if( force ){
      params.data.force = true;
    }
    return this.apiCall( 'GET', '/bitbucket/issues', params );
  },
  
  
   /*
   *  Trello
  */
  
  disconnectFromTrello: function( params ){
    return this.apiCall( 'GET', '/trello/disconnect', params );
  },
  
  getTrelloBoards: function( params, force ){
    if( force ){
      params.data.force = true;
    }
    return this.apiCall( 'GET', '/trello/boards', params );
  },
  
  updateTrelloList: function( listid, params ){
    return this.apiCall( 'POST', '/trello/list/' + listid, params );
  },
  
  getTrelloLists: function( params, force ){
    if( force ){
      params.data.force = true;
    }
    return this.apiCall( 'GET', '/trello/lists', params );
  },
  
  getTrelloCards: function( params, force ){
    if( force ){
      params.data.force = true;
    }
    return this.apiCall( 'GET', '/trello/cards', params );
  }
  
};